import React from "react"

export default function Content(props){
    return (
            <div className="content">
                <div dangerouslySetInnerHTML={{__html: props.pageContent}}></div>
            </div>
        )
}
